// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AutoTableRow {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
}

.auto-table-container {
  overflow-x: auto;
  overflow-y: hidden;
  max-width: 100%;
  border-radius: 2.8vh;
  border: 1px solid #fff !important;
  padding: 0;
}
.auto-table-container::-webkit-scrollbar {
  height: 10px;
  background: transparent;
  margin-right: 4px;
}
.auto-table-container::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 10px;
}

.AutoHeadImg {
  width: 120%;
}
@media (max-width: 990px) {
  .AutoHeadImg {
    width: 25vw;
  }
}

.auto-table {
  border-collapse: collapse;
  margin: -1px;
  width: 100%;
}
.auto-table_details {
  display: flex;
  justify-content: left;
}
.auto-table_details ul {
  color: #fff;
  list-style-type: none;
  padding: 0%;
}
.auto-table_details li {
  color: #fff;
  margin: 1.4vh 0;
  font-size: 2.2vh !important;
}
.auto-table_details-Col {
  width: 100%;
  display: flex;
  justify-content: left;
}
.auto-table_details-Col h4 {
  color: #fff;
  font-size: 2.5vh !important;
  margin-bottom: 0;
}

.auto-table th:nth-child(2),
.auto-table th:nth-child(3),
.auto-table th:nth-child(4),
.auto-table th:nth-child(5),
.auto-table th:nth-child(6),
.auto-table td:nth-child(2),
.auto-table td:nth-child(3),
.auto-table td:nth-child(4),
.auto-table td:nth-child(5),
.auto-table td:nth-child(6) {
  padding: 0;
}

.auto-table tr,
th {
  color: #fff;
  border: 1px solid #fff !important;
  text-align: left;
  padding: 1.3vw;
  font-size: 1.3vw;
}
@media (max-width: 990px) {
  .auto-table tr,
  th {
    font-size: 14px;
    padding: 8px;
  }
}

.auto-table td {
  color: #fff;
  border: 1px solid #fff !important;
  text-align: left;
  padding: 1.3vw;
  font-size: 1.3vw;
}
@media (max-width: 990px) {
  .auto-table td {
    font-size: 14px;
    padding: 8px;
  }
}

.AutoSmallText {
  font-size: 1vw;
  font-weight: 400;
}
@media (max-width: 990px) {
  .AutoSmallText {
    font-size: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/AutoTable/autoTable.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;AACF;;AAEA;EACE,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,iCAAA;EACA,UAAA;AACF;AAAE;EACE,YAAA;EACA,uBAAA;EACA,iBAAA;AAEJ;AACE;EACE,8BAAA;EACA,mBAAA;AACJ;;AAGA;EACE,WAAA;AAAF;AACE;EAFF;IAGI,WAAA;EAEF;AACF;;AACA;EACE,yBAAA;EACA,YAAA;EACA,WAAA;AAEF;AAAE;EACE,aAAA;EACA,qBAAA;AAEJ;AACE;EACE,WAAA;EACA,qBAAA;EACA,WAAA;AACJ;AAEE;EACE,WAAA;EACA,eAAA;EACA,2BAAA;AAAJ;AAGE;EACE,WAAA;EACA,aAAA;EACA,qBAAA;AADJ;AAIE;EACE,WAAA;EACA,2BAAA;EACA,gBAAA;AAFJ;;AAOE;;;;;;;;;;EAUE,UAAA;AAJJ;;AAQA;;EAEE,WAAA;EACA,iCAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AALF;AAME;EAPF;;IAQI,eAAA;IACA,YAAA;EAFF;AACF;;AAKA;EACE,WAAA;EACA,iCAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAFF;AAGE;EANF;IAOI,eAAA;IACA,YAAA;EAAF;AACF;;AAGA;EACE,cAAA;EACA,gBAAA;AAAF;AACE;EAHF;IAII,eAAA;EAEF;AACF","sourcesContent":[".AutoTableRow {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n}\n\n.auto-table-container {\n  overflow-x: auto;\n  overflow-y: hidden;\n  max-width: 100%;\n  border-radius: 2.8vh;\n  border: 1px solid #fff !important;\n  padding: 0;\n  &::-webkit-scrollbar {\n    height: 10px;\n    background: transparent;\n    margin-right: 4px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 10px;\n  }\n}\n\n.AutoHeadImg {\n  width: 120%;\n  @media (max-width: 990px) {\n    width: 25vw;\n  }\n}\n\n.auto-table {\n  border-collapse: collapse;\n  margin: -1px;\n  width: 100%;\n\n  &_details {\n    display: flex;\n    justify-content: left;\n  }\n\n  &_details ul {\n    color: #fff;\n    list-style-type: none;\n    padding: 0%;\n  }\n\n  &_details li {\n    color: #fff;\n    margin: 1.4vh 0;\n    font-size: 2.2vh !important;\n  }\n\n  &_details-Col {\n    width: 100%;\n    display: flex;\n    justify-content: left;\n  }\n\n  &_details-Col h4 {\n    color: #fff;\n    font-size: 2.5vh !important;\n    margin-bottom: 0;\n  }\n}\n\n.auto-table {\n  th:nth-child(2),\n  th:nth-child(3),\n  th:nth-child(4),\n  th:nth-child(5),\n  th:nth-child(6),\n  td:nth-child(2),\n  td:nth-child(3),\n  td:nth-child(4),\n  td:nth-child(5),\n  td:nth-child(6) {\n    padding: 0;\n  }\n}\n\n.auto-table tr,\nth {\n  color: #fff;\n  border: 1px solid #fff !important;\n  text-align: left;\n  padding: 1.3vw;\n  font-size: 1.3vw;\n  @media (max-width: 990px) {\n    font-size: 14px;\n    padding: 8px;\n  }\n}\n\n.auto-table td {\n  color: #fff;\n  border: 1px solid #fff !important;\n  text-align: left;\n  padding: 1.3vw;\n  font-size: 1.3vw;\n  @media (max-width: 990px) {\n    font-size: 14px;\n    padding: 8px;\n  }\n}\n\n.AutoSmallText {\n  font-size: 1vw;\n  font-weight: 400;\n  @media (max-width: 990px) {\n    font-size: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
